import useAlarmsByWorkspace from './useAlarmsByWorkspace';
import useAlarmsByGroup from './useAlarmsByGroup';
import { useAppSelector } from '../../store.model';
import { getMyWorkspaceSelector } from '../../workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../theme/ui/Dashboard/Dashboard.model';
import useAlarmsByWorkspaces from './useAlarmsByWorkspaces';
import useAlarmsByUser from './useAlarmsByUser';
import { patchLoadingState } from '../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';
import { AlarmsQueryParamsAPIRequest } from '../Alarm.model';

export interface IUseAlarmsProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
  params?: AlarmsQueryParamsAPIRequest;
}
function useAlarms(props: IUseAlarmsProps) {
  const { typeRequest, groupId, workspaceId, params } = props;
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const userDevicesAlarmCountResponse = useAlarmsByUser(params, {
    skip: typeRequest !== 'user' || !myWorkspace?.id,
  });

  const groupDevicesAlarmCountResponse = useAlarmsByGroup(
    {
      groupId: groupId ?? '',
      workspaceId: workspaceId,
      params,
    },
    {
      skip: typeRequest !== 'group' || !groupId,
    }
  );

  const workspaceDevicesAlarmCountResponse = useAlarmsByWorkspace(
    workspaceId ?? myWorkspace?.id,
    params,
    {
      skip: typeRequest !== 'workspace' || !workspaceId,
    }
  );

  const workspacesDevicesAlarmCountResponse = useAlarmsByWorkspaces(params, {
    skip: typeRequest !== 'workspaces' || !myWorkspace?.id,
  });

  switch (typeRequest) {
    case 'user':
      return patchLoadingState(userDevicesAlarmCountResponse);
    case 'group':
      return patchLoadingState(groupDevicesAlarmCountResponse);
    case 'workspace':
      return patchLoadingState(workspaceDevicesAlarmCountResponse);
    case 'workspaces':
      return patchLoadingState(workspacesDevicesAlarmCountResponse);
    default:
      return patchLoadingState(userDevicesAlarmCountResponse);
  }
}
export default useAlarms;
